import React from 'react'
export const deprecated_icon = {
  path: (
    <>
      <path d="M0.96 0.296a0.421 0.421 0 0 0 -0.333 -0.136l0.001 0H0.302a0.032 0.032 0 0 0 -0.032 0.032v0.896c0 0.018 0.014 0.032 0.032 0.032h0.326a0.42 0.42 0 0 0 0.332 -0.136l0 0a0.5 0.5 0 0 0 0.119 -0.345l0 0.001a0.501 0.501 0 0 0 -0.119 -0.344l0.001 0.001zM0.371 0.261h0.256a0.321 0.321 0 0 1 0.257 0.103l0 0a0.403 0.403 0 0 1 0.092 0.277l0 -0.001a0.402 0.402 0 0 1 -0.093 0.276l0.001 -0.001a0.321 0.321 0 0 1 -0.258 0.103l0.001 0H0.371z" />
    </>
  ),
  viewBox: '0 0 32 32',
}
